'use strict';
/**
 * @author Maxim Seredkin
 */
export default function () {
    return function (text) {
        text = text.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        return text;
    };
}